import * as regexp from 'utils/regexp'

export let getIconMap = () => ({
  'file-archive-o': regexp.archive_type(),
  'file-audio-o': regexp.audio_type(),
  'file-video-o': regexp.video_type(),
  'file-pdf-o': regexp.pdf_type(),
  'file-powerpoint-o': regexp.ppt_type(),
  'file-word-o': regexp.word_type(),
  'file-excel-o': regexp.excel_type(),
  'file-text-o': regexp.text_type(),
  'file-image-o': regexp.image_type(),
})

export let getIcon = filename => {
  let map = getIconMap()
  for (let icon of Object.keys(map)) {
    if (map[icon].test(filename)) return icon
  }
  return 'file-o'
}

export default getIcon



// WEBPACK FOOTER //
// ./src/utils/fileicon.js